
export interface Caregiver {
  id: string;
  name: string;
  role: string;
  experience: string;
  imageUrl: string;
  verified: boolean;
  specialization: string[];
}

export interface ServiceTier {
  id: string;
  title: string;
  description: string;
  features: string[];
  priceRange: string;
  icon: string;
}

export enum ViewMode {
  LANDING = 'LANDING',
  BOOKING = 'BOOKING',
  SAFETY = 'SAFETY'
}
